module.exports = __webpack_public_path__ + "img/yesica-wild.ea4d05e6.jpg";